import { withAuthRedirect } from '../hocs';
import { Panel, PanelHeader, PanelContent } from '../atoms';

const Reporting = () => {
  return (
    <Panel>
      <PanelHeader>
        <h1>Reporting</h1>
      </PanelHeader>
      <PanelContent>
        <h2>Coming Soon</h2>
      </PanelContent>
    </Panel>
  );
};

const SecureResetPassword = withAuthRedirect(Reporting);
export { SecureResetPassword as Reporting };
